export default {
  projectName: "تجربة",
  isRTL: true,
  dark: false,
  colors: {
    primary: "#187DA0", // orange
    secondary: "#6F96AA", // grey
    accent: "#3CC2E0", // cyan
    error: "#FF606B",// red,
    info: "#2196F3",
    success: "#2ED67B",// gren
    warning: "#FFC107",
    darkBackground: "#1E1E1E",
    lightBackground: "#F5F5F5"
  },
  backType: 'gradient',
  image: null,
  appbar: "light",
  drawer: "dark"
};
